import React, { FC, useState } from 'react';
import { ReactComponent as ReassignRiderIcon } from 'assets/icons/reassign-rider-modal-icon.svg';
import { toast } from 'react-toastify';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';
interface DispatchOrderModalProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
}

interface DispatchOrderFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DispatchOrderFooter: FC<DispatchOrderFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const DispatchOrderModal: FC<DispatchOrderModalProps> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);
  const dispatchOrder = async () => {
    setLoading(true);
    try {
      await apiService.post(`logistics/order/dispatched/${order.order_code}`, {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Updated successfully' />);
      onClose();
    } catch (err: any) {
      toast(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      title='Dispatch Order'
      description={`Are you sure you want to dispatch this order #${
        order?.order_code?.toUpperCase() ?? ''
      }`}
      titleIcon={<ReassignRiderIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <DispatchOrderFooter loading={loading} onCancel={onClose} onConfirm={dispatchOrder} />
      }
    />
  );
};

export default DispatchOrderModal;
